import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../Css/HomeDetails.css";
import forestviewImg from "../F-img/forest-view.png";
import SpringHouseImg from "../F-img/spring-house.png";
import RiseHouseImg from "../F-img/rise-house.png";
import { FaArrowTurnUp } from "react-icons/fa6";
const forestHomes = [
  {
    id: "forestView",
    title: "Forest View",
    tagline: "Where Every Child's Story Matters",
    tagcoming: "Coming Soon",
    overview:
      "Forest View is an Ofsted-registered residential children's home operated by Affinity Children's Services Limited. The home provides care for up to 3 children aged 7-17, subject to careful assessment and matching to ensure the home can meet each child's needs safely and consistently.",
    whoWeSupport: [
      "Emotional and behavioural difficulties",
      "Attachment challenges",
      "Trauma-related behaviours",
      "Difficulties engaging in education",
    ],
    whoWeSupportNote:
      "Placements are accepted only where the home can provide stability, safety, and appropriate support.",
    homeEnvironment:
      "The home is designed to feel warm, comfortable, and welcoming. Children are encouraged to personalise their bedrooms and contribute to decisions about communal areas, helping them develop a sense of ownership and belonging. The environment supports privacy, safety, and emotional wellbeing.",
    education: [
      "Schools and alternative education providers",
      "Virtual schools",
      "Health and mental health services",
    ],
    educationNote:
      "Children are supported to attend education, engage in learning, and access healthcare appointments as required.",
    therapeuticSupport: {
      approach:
        "Care is informed by trauma-aware practice, including Empathic Behaviour Management and Dyadic Developmental Practice.",
      focus: [
        "De-escalation",
        "Emotional regulation",
        "Relationship repair",
        "Reflective practice",
      ],
      consultation:
        "Where appropriate, therapeutic consultation supports staff understanding and consistency.",
    },
    familyTime: {
      description:
        "Children are supported to maintain and develop positive relationships with family and friends, subject to:",
      requirements: [
        "Risk assessment",
        "Placing authority agreements",
        "Individual care plans",
      ],
      note: "Family time arrangements are carefully planned to promote emotional safety and stability.",
    },
    leadership: {
      description:
        "Each home is led by a Registered Manager who is supported by a skilled and experienced staff team. Staff receive:",
      benefits: [
        "Regular supervision",
        "Ongoing training",
        "Annual appraisals",
        "Support to develop professionally",
      ],
      note: "This ensures care is delivered safely, consistently, and in line with regulatory expectations.",
    },
    downloads: [
      {
        name: "Statement of Purpose (PDF)",
        url: "/pdfs/forest-view-statement-of-purpose.pdf",
        size: "2.4 MB",
      },
    ],
    img: forestviewImg,
    address: "Hednesford, Cannock",
    bedrooms: 3,
    ageRange: "7-17",
    capacity: 3,
    ofstedRating: "Good",
    established: "2018",
    registrationNumber: "SC123456",
    features: [
      "Detached renovated home",
      "Three floors with conservatory",
      "Two lounges",
      "Main kitchen",
      "Enclosed rear garden",
      "Bathrooms for all children",
    ],
  },
  {
    id: "springhouse",
    title: "Spring House",
    tagline: "Nurturing Growth, Building Futures",
    tagcoming: "Coming Soon",
    overview:
      "Spring House is an Ofsted-registered residential children's home operated by Affinity Children's Services Limited. The home provides care for up to 3 children aged 7-17, subject to careful assessment and matching to ensure the home can meet each child's needs safely and consistently.",
    whoWeSupport: [
      "Emotional and behavioural difficulties",
      "Attachment challenges",
      "Trauma-related behaviours",
      "Difficulties engaging in education",
    ],
    whoWeSupportNote:
      "Placements are accepted only where the home can provide stability, safety, and appropriate support.",
    homeEnvironment:
      "The home is designed to feel warm, comfortable, and welcoming. Children are encouraged to personalise their bedrooms and contribute to decisions about communal areas, helping them develop a sense of ownership and belonging. The environment supports privacy, safety, and emotional wellbeing.",
    education: [
      "Schools and alternative education providers",
      "Virtual schools",
      "Health and mental health services",
    ],
    educationNote:
      "Children are supported to attend education, engage in learning, and access healthcare appointments as required.",
    therapeuticSupport: {
      approach:
        "Care is informed by trauma-aware practice, including Empathic Behaviour Management and Dyadic Developmental Practice.",
      focus: [
        "De-escalation",
        "Emotional regulation",
        "Relationship repair",
        "Reflective practice",
      ],
      consultation:
        "Where appropriate, therapeutic consultation supports staff understanding and consistency.",
    },
    familyTime: {
      description:
        "Children are supported to maintain and develop positive relationships with family and friends, subject to:",
      requirements: [
        "Risk assessment",
        "Placing authority agreements",
        "Individual care plans",
      ],
      note: "Family time arrangements are carefully planned to promote emotional safety and stability.",
    },
    leadership: {
      description:
        "Each home is led by a Registered Manager who is supported by a skilled and experienced staff team. Staff receive:",
      benefits: [
        "Regular supervision",
        "Ongoing training",
        "Annual appraisals",
        "Support to develop professionally",
      ],
      note: "This ensures care is delivered safely, consistently, and in line with regulatory expectations.",
    },
    downloads: [
      {
        name: "Statement of Purpose (PDF)",
        url: "/pdfs/spring-house-statement-of-purpose.pdf",
        size: "2.1 MB",
      },
    ],
    img: SpringHouseImg,
    address: "Cannock, Staffordshire",
    bedrooms: 3,
    ageRange: "7-17",
    capacity: 3,
    ofstedRating: "Good",
    established: "2019",
    registrationNumber: "SC123457",
    features: [
      "Modern interior design",
      "Spacious garden",
      "Activity room",
      "Quiet study area",
      "Sensory space",
      "Communal lounge",
    ],
  },
  {
    id: "risehouse",
    title: "Rise House",
    tagline: "Empowering Young Lives",
    tagcoming: "Coming Soon",
    overview:
      "Rise House is an Ofsted-registered residential children's home operated by Affinity Children's Services Limited. The home provides care for up to 2 children aged 7-17, subject to careful assessment and matching to ensure the home can meet each child's needs safely and consistently.",
    whoWeSupport: [
      "Emotional and behavioural difficulties",
      "Attachment challenges",
      "Trauma-related behaviours",
      "Difficulties engaging in education",
    ],
    whoWeSupportNote:
      "Placements are accepted only where the home can provide stability, safety, and appropriate support.",
    homeEnvironment:
      "The home is designed to feel warm, comfortable, and welcoming. Children are encouraged to personalise their bedrooms and contribute to decisions about communal areas, helping them develop a sense of ownership and belonging. The environment supports privacy, safety, and emotional wellbeing.",
    education: [
      "Schools and alternative education providers",
      "Virtual schools",
      "Health and mental health services",
    ],
    educationNote:
      "Children are supported to attend education, engage in learning, and access healthcare appointments as required.",
    therapeuticSupport: {
      approach:
        "Care is informed by trauma-aware practice, including Empathic Behaviour Management and Dyadic Developmental Practice.",
      focus: [
        "De-escalation",
        "Emotional regulation",
        "Relationship repair",
        "Reflective practice",
      ],
      consultation:
        "Where appropriate, therapeutic consultation supports staff understanding and consistency.",
    },
    familyTime: {
      description:
        "Children are supported to maintain and develop positive relationships with family and friends, subject to:",
      requirements: [
        "Risk assessment",
        "Placing authority agreements",
        "Individual care plans",
      ],
      note: "Family time arrangements are carefully planned to promote emotional safety and stability.",
    },
    leadership: {
      description:
        "Each home is led by a Registered Manager who is supported by a skilled and experienced staff team. Staff receive:",
      benefits: [
        "Regular supervision",
        "Ongoing training",
        "Annual appraisals",
        "Support to develop professionally",
      ],
      note: "This ensures care is delivered safely, consistently, and in line with regulatory expectations.",
    },
    downloads: [
      {
        name: "Statement of Purpose (PDF)",
        url: "/pdfs/rise-house-statement-of-purpose.pdf",
        size: "2.3 MB",
      },
    ],
    img: RiseHouseImg,
    address: "Rugeley, Staffordshire",
    bedrooms: 2,
    ageRange: "7-17",
    capacity: 2,
    ofstedRating: "Good",
    established: "2020",
    registrationNumber: "SC123458",
    features: [
      "Contemporary design",
      "Therapeutic spaces",
      "Quiet zones",
      "Creative areas",
      "Outdoor play area",
      "Modern kitchen",
    ],
  },
];

function HomeDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const home = forestHomes.find((item) => item.id === id);

  if (!home) {
    return <h2 className="home-not-found">Home not found</h2>;
  }

  const handleGoBack = () => {
    navigate(-1); // Goes back to previous page
  };
  return (
    <section className="home-details">
      <span className="go-top">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <FaArrowTurnUp />
        </button>
      </span>
      {/* Hero Section */}
      <div className="hero-section">
        <div className="container">
          <div className="hero-image-wrapper">
            <img src={home.img} alt={home.title} className="hero-image" />
            <div className="hero-overlay">
              <div className="container">
                <button className="go-back-button" onClick={handleGoBack}>
                  <span className="back-arrow">←</span> Back
                </button>
              </div>
            </div>
          </div>
          <div className="hero-content">
            <div className="container">
              {/* Key Information Strip 
              <div className="hero-badge">
                Ofsted Registered • {home.ofstedRating}
                {home.title.includes("Coming Soonssssss") && (
                  <span className="coming-soon-badge"></span>
                )}
              </div>*/}
              <h1 className="hero-title">
                {home.title}{" "}
                {home.id !== "forestView" && (
                  <span className="meta-text meta-item coming-soon">
                    {home.tagcoming}
                  </span>
                )}
              </h1>
              <p className="hero-tagline">{home.tagline}</p>
              <div className="hero-meta">
                <div className="meta-item">
                  <span className="meta-icon">👥</span>
                  <span className="meta-text">
                    Capacity: {home.capacity}{" "}
                    {home.capacity === 1 ? "child" : "children"}
                  </span>
                </div>
                <div className="meta-item">
                  <span className="meta-icon">🛏️</span>
                  <span className="meta-text">
                    {home.bedrooms}{" "}
                    {home.bedrooms === 1 ? "Bedroom" : "Bedrooms"}
                  </span>
                </div>
                <div className="meta-item">
                  <span className="meta-icon">📅</span>
                  <span className="meta-text">Ages {home.ageRange}</span>
                </div>
                {/* Key Information Strip
                <div className="meta-item">
                  <span className="meta-icon">📍</span>
                  <span className="meta-text">{home.address}</span>
                </div>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        {/* Key Information Strip 
        <div className="info-strip">
          <div className="strip-item">
            <span className="strip-label">Registration No.</span>
            <span className="strip-value">{home.registrationNumber}</span>
          </div>
          <div className="strip-item">
            <span className="strip-label">Established</span>
            <span className="strip-value">{home.established}</span>
          </div>
          <div className="strip-item">
            <span className="strip-label">Ofsted Rating</span>
            <span className="strip-value ofsted-badge">
              {home.ofstedRating}
            </span>
          </div>
          <div className="strip-item">
            <span className="strip-label">Provider</span>
            <span className="strip-value">
              Affinity Children's Services Limited
            </span>
          </div>
        </div>*/}

        {/* Overview Section */}
        <div className="detail-card">
          <div className="card-header">
            <div className="header-icon">📋</div>
            <h2 className="card-title">Overview</h2>
          </div>
          <div className="card-body my-3">
            <p className="overview-text">{home.overview}</p>
          </div>
        </div>

        {/* Who We Support Section */}
        <div className="detail-card">
          <div className="card-header">
            <div className="header-icon">🤝</div>
            <h2 className="card-title">Who We Support</h2>
          </div>
          <div className="card-body my-3">
            <p className="section-intro therapeutic-approach">
              The home supports children and young people who may present with:
            </p>
            <div className="support-grid">
              {home.whoWeSupport.map((item, index) => (
                <div key={index} className="support-item">
                  <span className="support-dot"></span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <div className="note-box">
              <span className="note-icon">ℹ️</span>
              <p>{home.whoWeSupportNote}</p>
            </div>
          </div>
        </div>

        {/* The Home Environment Section */}
        <div className="detail-card">
          <div className="card-header">
            <div className="header-icon">🏡</div>
            <h2 className="card-title">The Home Environment</h2>
          </div>
          <div className="card-body my-3">
            <p className="environment-text therapeutic-approach">
              {home.homeEnvironment}
            </p>
            <div className="features-grid">
              {home.features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Education & Health Section */}
        <div className="detail-card">
          <div className="card-header">
            <div className="header-icon">📚</div>
            <h2 className="card-title">Education & Health</h2>
          </div>
          <div className="card-body my-3">
            <p className="section-intro therapeutic-approach">
              Education and health are prioritised within the home. We work in
              partnership with:
            </p>
            <div className="partners-list">
              {home.education.map((item, index) => (
                <div key={index} className="partner-item">
                  <span className="partner-arrow">→</span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <div className="note-box">
              <span className="note-icon">💡</span>
              <p>{home.educationNote}</p>
            </div>
          </div>
        </div>

        {/* Therapeutic & Behaviour Support Section */}
        <div className="detail-card">
          <div className="card-header">
            <div className="header-icon">🌿</div>
            <h2 className="card-title">Therapeutic & Behaviour Support</h2>
          </div>
          <div className="card-body my-3">
            <p className="therapeutic-approach">
              {home.therapeuticSupport.approach}
            </p>
            <h3 className="section-subtitle">Staff focus on:</h3>
            <div className="focus-grid">
              {home.therapeuticSupport.focus.map((item, index) => (
                <div key={index} className="focus-item">
                  <span className="focus-bullet">•</span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
            {home.therapeuticSupport.consultation && (
              <div className="note-box">
                <span className="note-icon">🔄</span>
                <p>{home.therapeuticSupport.consultation}</p>
              </div>
            )}
          </div>
        </div>

        {/* Family Time & Relationships Section */}
        <div className="detail-card">
          <div className="card-header">
            <div className="header-icon">👨‍👩‍👧‍👦</div>
            <h2 className="card-title">Family Time & Relationships</h2>
          </div>
          <div className="card-body my-3">
            <p className="section-intro therapeutic-approach">
              {home.familyTime.description}
            </p>
            <div className="requirements-list">
              {home.familyTime.requirements.map((item, index) => (
                <div key={index} className="requirement-item">
                  <span className="requirement-number">{index + 1}</span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <div className="note-box family-note">
              <span className="note-icon">❤️</span>
              <p>{home.familyTime.note}</p>
            </div>
          </div>
        </div>

        {/* Leadership & Staffing Section */}
        <div className="detail-card">
          <div className="card-header">
            <div className="header-icon">👥</div>
            <h2 className="card-title">Leadership & Staffing</h2>
          </div>
          <div className="card-body my-3">
            <p className="leadership-text therapeutic-approach">
              {home.leadership.description}
            </p>
            <div className="benefits-grid">
              {home.leadership.benefits.map((item, index) => (
                <div key={index} className="benefit-item">
                  <span className="benefit-check">✓</span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <div className="leadership-note">
              <span className="note-icon">🏆</span>
              <p>{home.leadership.note}</p>
            </div>
          </div>
        </div>

        {/* Downloads Section
        <div className="detail-card">
          <div className="card-header">
            <div className="header-icon">📥</div>
            <h2 className="card-title">Downloads</h2>
          </div>
          <div className="card-body">
            <div className="downloads-list">
              {home.downloads.map((download, index) => (
                <a
                  key={index}
                  href={download.url}
                  className="download-item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="download-icon">
                    <span className="pdf-icon">📄</span>
                  </div>
                  <div className="download-info">
                    <span className="download-name">{download.name}</span>
                    <span className="download-meta">
                      <span className="download-size">{download.size}</span>
                      <span className="download-format">PDF</span>
                    </span>
                  </div>
                  <span className="download-action">Download</span>
                </a>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}

export default HomeDetails;
